const doc = [({"en":({"js":({"shared":({"preview":({"index":({"unknown_type":"Unknown type"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;